import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-productlist',
  templateUrl: './productlist.component.html',
  styleUrls: ['./productlist.component.css']
})
export class ProductlistComponent implements OnInit {
   imagesUrl:any;
  constructor() {


   }




  ngOnInit() {
    this.imagesUrl = ['https://madeeasypublications.org/images/banner/199.jpg?v=1572935225', 'https://madeeasypublications.org/images/banner/171.jpg?v=1572935225', 'https://madeeasypublications.org/images/banner/201.jpg?v=1572935225'];
}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/ecommerce/productlist/productlist.component.ts